import { yupResolver } from "@hookform/resolvers/yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { handleError } from "../../../../shared/functions/handleError";
import { ILoginUser } from "../../../../shared/interfaces/user/IUser";
import authSlice from "../../../../store/slices/auth.slice";
import { AuthService } from "../../service";

const schema = yup.object().shape({
  email: yup.string().email().required("validation.required"),
  password: yup
    .string()
    .min(6, "validation.minLength")
    .max(32, "validation.maxLength")
    .required("validation.required"),
});
const LoginForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleSubmit, control } = useForm<ILoginUser>({
    defaultValues: {
      email: "",
      password: "",
    },
    resolver: yupResolver(schema),
  });
  const [showPassword, setShowPassword] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = (formState: ILoginUser) => {
    AuthService.login(formState)
      .then((response) => {
        if (response) {
          dispatch(
            authSlice.actions.setLoginState({
              ...response,
              isAuthenticated: true,
            }),
          );

          navigate("/dashboard");
          enqueueSnackbar(t("toasts.successfullyLoggedIn"), {
            variant: "success",
          });

          localStorage.setItem("token", response?.token);
        }
      })
      .catch(handleError);
  };
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        width: "75%",
      }}
    >
      <Typography variant="h4">{t("general.login.welcome")} 👋</Typography>

      <Typography variant="subtitle1">
        {t("general.login.pleaseLoginHere")}
      </Typography>
      <Box sx={{ margin: "20px 0" }}>
        <Controller
          name={"email"}
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              error={!!error?.message}
              helperText={t(error?.message as string, {
                minLength: 6,
                maxLength: 32,
              })}
              value={value ?? ""}
              onChange={onChange}
              label={t("general.login.email")}
              sx={{ width: "100%" }}
            />
          )}
        />
      </Box>
      <Box
        sx={{
          marginBottom: "10px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Controller
          name={"password"}
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              error={!!error?.message}
              helperText={t(error?.message as string, {
                minLength: 6,
                maxLength: 32,
              })}
              value={value ?? ""}
              onChange={onChange}
              type={showPassword ? "text" : "password"}
              label="Password"
              sx={{ width: "100%" }}
            />
          )}
        />
        <Box
          sx={{ marginLeft: "-40px", position: "relative", cursor: "pointer" }}
        >
          {showPassword ? (
            <VisibilityOff onClick={() => setShowPassword((prev) => !prev)} />
          ) : (
            <Visibility onClick={() => setShowPassword((prev) => !prev)} />
          )}
        </Box>
      </Box>

      <Button
        variant={"contained"}
        sx={{ width: "100%", marginTop: "20px" }}
        type={"submit"}
      >
        {t("button.login")}
      </Button>
    </form>
  );
};

export default LoginForm;
